// var baseURL = location.origin + '/assets/common/js/m/'
var baseURL = '/assets/common/js/m/'
var nr = {
  currentId: '',
  // baseURL: location.origin + '/assets/common/js/',
  // 模块缓存
  modules: {},

  // 默认配置
  config: {
    root: '/',
    paths: {
      'jquery': baseURL + 'jquery-3.2.1.js',
      'api-common': baseURL + 'api-common.js',
      'common': baseURL + 'common.js',
      'cookie': baseURL + 'cookie.js',
      'arale-cookie': baseURL + 'arale-cookie.js',
      'md5': baseURL + 'md5.js',
      'memory': baseURL + 'memory.js',
      'login': baseURL + 'login.js',
    }
  }
}

// 构造函数
function Module (id) {
  nr.modules[id] = this // 缓存模块
  this.id = id
  this.factory = null // 执行代码
  this.dependences = null // 依赖
  this.load()
}

// 静态方法创建模块
Module.create = function (id) {
  return new Module(id)
}

// 通过xhr请求加载模块
Module.prototype.load = function () {
  var that = this
  var url = that.id
  var xhr = new XMLHttpRequest()
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4) {
      if (xhr.status >= 200 && xhr.status < 300 || xhr.status === 304) {
        nr.currentId = url
        eval(xhr.responseText)
      }
    }
  }
  // console.log(url)
  xhr.open('GET', url, false)
  xhr.send(null)
}

nr.define = function (factory) {
  var id = nr.currentId
  var mod = nr.modules[id]
  var dependences = mod.dependences = getDenpendence(factory.toString())
  mod.factory = factory

  if (dependences) {
    dependences.forEach(function (id) {
      id = nr.config.paths[id]
      if (!nr.modules[id]) {
        Module.create(id)
      }
    })
  }
}

// 用正则匹配模块中的依赖，这里只做简单的提取，实际需要考虑更多情况，参考seajs
function getDenpendence (factory) {
  var list = factory.match(/require\(.+?\)/g)
  if (list) {
    list = list.map(function (dep) {
      return dep.replace(/(^require\(['"])|(['"]\)$)/g, '')
    })
  }
  return list
}

// 获取模块的返回值
function getModuleExports (mod) {
  if (!mod.exports) {
    mod.exports = {}
    mod.exports = mod.factory(nr.require, mod.exports, mod) || mod.exports
  }
  return mod.exports
}

// 取得模块依赖的值
nr.require = function (id) {
  id = nr.config.paths[id]
  var mod = nr.modules[id]
  if (mod) {
    return getModuleExports(mod)
  } else {
    throw 'can not get module by from:' + id
  }
}

nr.loadScript = function (id) {
  id = nr.config.paths[id]
  var mod = nr.modules[id] || Module.create(id)
  return getModuleExports(mod)
}

window.define = nr.define
window.nr = nr

export default nr



// WEBPACK FOOTER //
// ./src/assets/js/common/nr.js